module.exports = __webpack_public_path__ + "static/17-aerial-views-ii-7642369a32b6997980ddab4e040666bc.jpeg";